<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('samSet.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="title">
                {{ $t('samSet.title') }}
            </div>
            <div class="text">{{ $t('samSet.p0') }}</div>
            <div class="sub-title">{{ $t('samSet.p1') }}</div>
            <div class="text">
                {{ $t('samSet.p2') }}
            </div>
            <div class="text">
                {{ $t('samSet.p3') }}
            </div>
            <div class="line"></div>
            <div class="sub-title">{{ $t('samSet.p4') }}</div>
            <div class="text">
                {{ $t('samSet.p5') }}
            </div>
            <div class="text">
                {{ $t('samSet.p6') }}
            </div>
            <img class="s-img" :src="require(`@/assets/theme/${theme}/article/samSet/s1${l}.png`)">
            <div class="text">{{ $t('samSet.p7') }} <span class="bold"> {{ $t('samSet.p8') }}</span></div>
            <img class="s-img" :src="require(`@/assets/theme/${theme}/article/samSet/s2${l}.png`)">
            <div class="text">{{ $t('samSet.p9') }} <span class="bold"> {{ $t('samSet.p10') }}</span></div>
            <img class="s-img" :src="require(`@/assets/theme/${theme}/article/samSet/s3${l}.png`)">
            <div class="text">{{ $t('samSet.p11') }} <span class="bold"> {{ $t('samSet.p12') }}  </span>{{ $t('samSet.p13') }}</div>
            <img class="s-img" :src="require(`@/assets/theme/${theme}/article/samSet/s4${l}.png`)">
        </div>
    </div>
</template>

<script>
import {getQueryVariable} from '@/utils/comment'

export default {
    name: 'samSet',
    data() {
        return {
            theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
            l: getQueryVariable("lang") == 'en' ? "en" : "",
        }
    },
    methods: {
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        }
    },
}
</script>

<style scoped>
    .content {
        color: var(--text-color-1);
    }

    .title {
        padding: 17px 37px;
        font-size: 17px;
        line-height: 28px;
        text-align: center;
        font-weight: 600;
    }

    .text {
        font-size: 13px;
        font-weight: 400;
        line-height: 20px;
        margin: 0 21px;
    }

    .sub-title {
        font-size: 13px;
        font-weight: bold;
        margin-left: 21px;
        margin-top: 18px;
        margin-bottom: 11px;
    }

    .line {
        margin: 18px 21px;
        border-bottom: 1px solid #C8C8C8;
    }

    .s-img {
        width: 151px;
        margin: 16px 112px;
    }

    .bold {
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/views/article/samSet.vue